module.exports = {"body":"<p>Like decks, a porch is a great area for outside entertainment and relaxation. From open\nair to screened in, to a completely enclosed three or four season, we have the ability\nand understanding to construct your ideal porch.</p>\n<p>Whatever porch you have in mind, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Porches.md
// module id = 517
// module chunks = 0